/**
 * Keeps the Video block's "Play/pause button only" toggle in step with the real video.
 *
 * Horizon's deferred-media reveals its play/pause toggle only after a click-to-play, so on an
 * autoplaying video the button would never appear, and its `isPlaying` flag would start out
 * wrong. Syncing from the video's own events also covers a browser that blocks autoplay.
 */
await customElements.whenDefined('deferred-media');

const SELECTOR = 'deferred-media.sd-video-play-pause';

/** @param {EventTarget | null} video */
function sync(video) {
  if (!(video instanceof HTMLVideoElement)) return;
  const media = video.closest(SELECTOR);
  if (!media) return;
  // The "Load video" poster button stays focusable under the video, and pressing it would add a
  // second copy that this toggle can't pause.
  media.refs.deferredMediaPlayButton?.setAttribute('inert', '');
  media.isPlaying = !video.paused;
  media.updatePlayPauseHint(media.isPlaying);
}

// Delegated (media events don't bubble, so capture), which also covers blocks the theme editor
// adds after this module ran.
for (const type of ['play', 'pause', 'loadedmetadata']) {
  document.addEventListener(type, (event) => sync(event.target), true);
}

// Autoplay may have started before this module ran.
for (const video of document.querySelectorAll(`${SELECTOR} video`)) sync(video);
